import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { JwtWrapperService } from '../jwt-wrapper.service';
import { LocationService } from '../../location/location.service';
import { UserService } from '../../user/user.service';

@Injectable({
  providedIn: 'root',
})
export class AuthGuard implements CanActivate {
  constructor(
    private jwtWrapperService: JwtWrapperService,
    private router: Router,
    private locationService: LocationService,
    private userService: UserService,
  ) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    // Vérification de la présence du jwtoken
    if (!this.jwtWrapperService.isLoggedIn()) {
      // Dans le cas ou aucun jeton n'est valide
      const currentRoute = state.url;
      this.router.navigate(['/login'], { queryParams: { redirectUrl: currentRoute } });
      return false;
    }

    // Vérification spécifique pour EXTERNAL_INSTALLER
    const userRole = this.userService.getRole();
    if (userRole === 'EXTERNAL_INSTALLER') {
      // Les utilisateurs EXTERNAL_INSTALLER ne peuvent accéder qu'aux URLs se terminant par /check
      // qui correspondent aux pages de vérification d'installation
      if (state.url !== '/' && !state.url.endsWith('/check')) {
        console.log('AuthGuard - EXTERNAL_INSTALLER trying to access unauthorized URL:', state.url);
        this.router.navigate(['/not-authorized']);
        return false;
      }
    }

    const locationId = route.params['locationId'];
    if (locationId != undefined && !this.locationService.hasUserOsmozisAvailableLocation(locationId)) {
      this.router.navigate(['/not-authorized']);
      return false;
    }

    return true;
  }
}
